// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
    display: flex;
    list-style-type: none;
    justify-content: space-evenly;
}
.pagination-container .pagination-item {
    padding: 0 12px;
    height: 32px;
    text-align: center;
    margin: auto 4px;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    box-sizing: border-box;
    align-items: center;
    letter-spacing: 0.01071em;
    border-radius: 16px;
    line-height: 1.43;
    font-size: 13px;
    min-width: 32px;
}
.pagination-container .pagination-item.dots:hover {
    background-color: transparent;
    cursor: default;
}
.pagination-container .pagination-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
    cursor: pointer;
}
.pagination-container .pagination-item.selected {
    background-color: rgba(0, 0, 0, 0.08);
}
.pagination-container .pagination-item .arrow::before {
    position: relative;
   /* top: 3pt;
    Uncomment this to lower the icons as requested in comments*/
    content: '';
   /* By using an em scale, the arrows will size with the font */
    display: inline-block;
    width: 0.4em;
    height: 0.4em;
    border-right: 0.12em solid rgba(0, 0, 0, 0.87);
    border-top: 0.12em solid rgba(0, 0, 0, 0.87);
}
.pagination-container .pagination-item .arrow.left {
    transform: rotate(-135deg) translate(-50%);
}
.pagination-container .pagination-item .arrow.right {
    transform: rotate(45deg);
}
.pagination-container .pagination-item.disabled {
    pointer-events: none;
}
.pagination-container .pagination-item.disabled .arrow::before {
    border-right: 0.12em solid rgba(0, 0, 0, 0.43);
    border-top: 0.12em solid rgba(0, 0, 0, 0.43);
}
.pagination-container .pagination-item.disabled:hover {
    background-color: transparent;
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pagination/pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,qCAAqC;IACrC,eAAe;AACnB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,kBAAkB;GACnB;+DAC4D;IAC3D,WAAW;GACZ,6DAA6D;IAC5D,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,8CAA8C;IAC9C,4CAA4C;AAChD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,8CAA8C;IAC9C,4CAA4C;AAChD;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":[".pagination-container {\n    display: flex;\n    list-style-type: none;\n    justify-content: space-evenly;\n}\n.pagination-container .pagination-item {\n    padding: 0 12px;\n    height: 32px;\n    text-align: center;\n    margin: auto 4px;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    letter-spacing: 0.01071em;\n    border-radius: 16px;\n    line-height: 1.43;\n    font-size: 13px;\n    min-width: 32px;\n}\n.pagination-container .pagination-item.dots:hover {\n    background-color: transparent;\n    cursor: default;\n}\n.pagination-container .pagination-item:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    cursor: pointer;\n}\n.pagination-container .pagination-item.selected {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n.pagination-container .pagination-item .arrow::before {\n    position: relative;\n   /* top: 3pt;\n    Uncomment this to lower the icons as requested in comments*/\n    content: '';\n   /* By using an em scale, the arrows will size with the font */\n    display: inline-block;\n    width: 0.4em;\n    height: 0.4em;\n    border-right: 0.12em solid rgba(0, 0, 0, 0.87);\n    border-top: 0.12em solid rgba(0, 0, 0, 0.87);\n}\n.pagination-container .pagination-item .arrow.left {\n    transform: rotate(-135deg) translate(-50%);\n}\n.pagination-container .pagination-item .arrow.right {\n    transform: rotate(45deg);\n}\n.pagination-container .pagination-item.disabled {\n    pointer-events: none;\n}\n.pagination-container .pagination-item.disabled .arrow::before {\n    border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n    border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n}\n.pagination-container .pagination-item.disabled:hover {\n    background-color: transparent;\n    cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
